const SCHEMA: string = process.env.REACT_APP_MASTER_MAIN_SCHEMA || '';
const ENTITY: string = process.env.REACT_APP_MASTER_MAIN_ENTITY || '';
const LIST_RENDICION: string = `/${process.env.REACT_APP_ROUTE_PATH_MAIN}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA_RENDIDOR_RENDICION_GASTOS}`;

export const AdapterConfigure = {
    SCHEMA,
    ENTITY,
    LIST_RENDICION
};